import {type TranslationObject} from '@colonist/i18n'
import {UIRoomWarningPopupContentBase} from './UIRoomWarningPopupContentBase.ts'

export class StartGameExceedLimitWarningContent extends UIRoomWarningPopupContentBase {
    shouldShowWarning() {
        return this.roomState.gameSetting.victoryPointsToWin > this.roomState.victoryPointsRecommendedLimit
    }

    // eslint-disable-next-line class-methods-use-this
    getTitle(): TranslationObject {
        return {key: 'strings:roomPage.warnings.startGameExceedLimitWarning.title'}
    }

    // eslint-disable-next-line class-methods-use-this
    getDescription(): TranslationObject {
        return {key: 'strings:roomPage.warnings.startGameExceedLimitWarning.description'}
    }
}
